document.addEventListener('DOMContentLoaded',()=>{
  const menuButton=document.querySelector('.menu-toggle');
  const menu=document.querySelector('#mobile-menu');
  if(menuButton&&menu){
    menuButton.addEventListener('click',()=>{
      const isOpen=menuButton.getAttribute('aria-expanded')==='true';
      menuButton.setAttribute('aria-expanded',String(!isOpen));
      menuButton.setAttribute('aria-label',isOpen?'Apri menu':'Chiudi menu');
      menu.hidden=isOpen;
    });
  }

  const sortSelect=document.querySelector('[data-collection-sort]');
  if(sortSelect){
    sortSelect.addEventListener('change',event=>{
      const url=new URL(window.location.href);
      url.searchParams.set('sort_by',event.target.value);
      url.searchParams.delete('page');
      window.location.href=url.toString();
    });
  }

  const mobileBuy=document.querySelector('[data-mobile-buy]');
  const productForm=document.querySelector('.product-form');
  if(mobileBuy&&productForm&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{mobileBuy.hidden=entries[0].isIntersecting;},{threshold:.15});
    observer.observe(productForm);
  }
});
